import { SxProps, Theme } from '@mui/material';

export const DpTextH2SX: SxProps<Theme> = {
	fontSize: {
		xs: 'var(--font-size-lg)',
		sm: 'var(--font-size-xl)',
	},
	fontWeight: '800',
	color: '#2C2C2C',
	marginBottom: '20px',
};
